import { EMemberRoles, ERegistrantRoles, NAMES_MEMBER_ROLES } from '../../config';

interface IFormatUserRoleParams {
  role: EMemberRoles | ERegistrantRoles | null;
  share?: string;
}

export const formatUserRole = ({ role, share }: IFormatUserRoleParams) => {
  if (!role) return null;
  const percent =
    (share ? ` · ${share}%` : '');
  return `${NAMES_MEMBER_ROLES[role as EMemberRoles]}${percent}`
}